module.exports = __webpack_public_path__ + "static/img/motorbike-white.8c7f6cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-white.svg
// module id = +nyJ
// module chunks = 82